module.exports = __webpack_public_path__ + "static/media/ed-roman-3.11bb7aec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/ed-roman-3.jpg
// module id = 221
// module chunks = 0